/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Preset_Not_FoundInputs */

const en_subtitle_export_preset_not_found = /** @type {(inputs: Subtitle_Export_Preset_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preset not found`)
};

const fr_subtitle_export_preset_not_found = /** @type {(inputs: Subtitle_Export_Preset_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Préréglage introuvable`)
};

const de_subtitle_export_preset_not_found = /** @type {(inputs: Subtitle_Export_Preset_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voreinstellung nicht gefunden`)
};

const it_subtitle_export_preset_not_found = /** @type {(inputs: Subtitle_Export_Preset_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preimpostazione non trovata`)
};

const ru_subtitle_export_preset_not_found = /** @type {(inputs: Subtitle_Export_Preset_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительно заданные параметры не найдены`)
};

const es_subtitle_export_preset_not_found = /** @type {(inputs: Subtitle_Export_Preset_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preajuste no encontrado`)
};

const zh_cn2_subtitle_export_preset_not_found = /** @type {(inputs: Subtitle_Export_Preset_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到预设`)
};

const ja_subtitle_export_preset_not_found = /** @type {(inputs: Subtitle_Export_Preset_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットが見つかりません`)
};

const hi_subtitle_export_preset_not_found = /** @type {(inputs: Subtitle_Export_Preset_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रीसेट नहीं मिला`)
};

const pt_pt2_subtitle_export_preset_not_found = /** @type {(inputs: Subtitle_Export_Preset_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Predefinição não encontrada`)
};

/**
* | output |
* | --- |
* | "Preset not found" |
*
* @param {Subtitle_Export_Preset_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_preset_not_found = /** @type {((inputs?: Subtitle_Export_Preset_Not_FoundInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Preset_Not_FoundInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_preset_not_found(inputs)
	if (locale === "de") return de_subtitle_export_preset_not_found(inputs)
	if (locale === "it") return it_subtitle_export_preset_not_found(inputs)
	if (locale === "ru") return ru_subtitle_export_preset_not_found(inputs)
	if (locale === "es") return es_subtitle_export_preset_not_found(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_preset_not_found(inputs)
	if (locale === "ja") return ja_subtitle_export_preset_not_found(inputs)
	if (locale === "hi") return hi_subtitle_export_preset_not_found(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_preset_not_found(inputs)
	return en_subtitle_export_preset_not_found(inputs)
});